import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m10.586 9.586-3.172 3.171c-1.26 1.26-.368 3.415 1.414 3.415h6.343c1.782 0 2.675-2.155 1.415-3.415l-3.172-3.171a2 2 0 0 0-2.828 0"
    }
  )
);
var SvgArrowUpFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ArrowUpFilled_default = SvgArrowUpFilled;

export { ArrowUpFilled_default as default };
